import {
	POSTS_FETCH,
	POSTS_FETCH_ERROR,
	POST_GET,
	POST_ADD,
	POST_LOADING_STATUS,
	POST_GET_ERROR,
	POST_ADD_ERROR,
	POST_UPDATE,
	POST_UPDATE_ERROR,
	POST_DELETE,
	POST_DELETE_ERROR,
	POSTS_FETCH_BY_AUTHOR,
	POSTS_FETCH_BY_AUTHOR_ERROR,
	POST_COMMENT_ADD,
	POST_COMMENT_ADD_STATUS,
	POST_COMMENT_ADD_ERROR,
	POST_COMMENT_GET,
	POST_COMMENTS_GET,
	POST_COMMENT_GET_STATUS,
	POST_COMMENT_GET_ERROR,
	POST_COMMENT_UPDATE,
	POST_COMMENT_UPDATE_ERROR,
	POST_COMMENT_UPDATE_STATUS,
	POST_COMMENT_REPLY,
	POST_COMMENT_REPLY_STATUS,
	POST_COMMENT_REPLY_ERROR,
	POST_COMMENT_DELETE,
	POST_COMMENT_DELETE_STATUS,
	POST_COMMENT_DELETE_ERROR,
	POSTS_NEARBY_FETCH,
	POSTS_NEARBY_FETCH_LOADING,
	POSTS_NEARBY_FETCH_ERROR,
	POST_FEATURED_GET,
	POST_FEATURED_LOADING,
	POST_REPORT,
	POST_REPORT_STATUS,
	POST_REPORT_ERROR,
	POST_VIOLATIONS_GET,
	POST_VIOLATIONS_GET_ERROR,
	POST_COMMENT_REPLY_DELETE,
	POST_COMMENT_REPLY_DELETE_ERROR,
	POST_COMMENT_REPLY_DELETE_STATUS,
	POSTS_FETCH_BY_CATEGORY,
	POST_EVENT_COMMENT_ADD,
	POST_EVENT_COMMENT_ADD_STATUS,
	POST_EVENT_COMMENT_ADD_ERROR,
	POST_UPLOAD_FILE,
	POST_FILE_LOADING_STATUS,
	POST_GET_ERROR_NOT_FOUND,
	POST_COMMENT_LIKE_STATUS,
	POST_COMMENT_LIKE,
	POST_COMMENT_LIKE_ERROR,
	POST_POLL_VOTING,
	POST_POLL_VOTING_ERROR,
	POST_POLL_LIST_UPDATE,
	POST_UPDATE_STATUS,
	POST_POLL_TIMER,
	POST_POLL_TIMER_LOADING,
	POST_POLL_USERS_LOADING,
	POST_POLL_USERS,
	POST_POLL_STOP,
	POST_VIDEO_PREVIEW,
	POST_VIDEO_PREVIEW_LOADING,
	POST_VIDEO_PREVIEW_ERROR,
} from './types'

const initialState = {
	commentDeleting: false,
	commentLoading: false,
	commentUpdating: false,
	commentAdding: false,
	reportAdding: false,
	replyLoading: false,
	loading: false,
	isPostUpdating: false,
	post: {},
	featuredPost: {},
	featuredPostLoading: false,
	categories: [],
	postNotFound: false,
	posts: [],
	comments: [],
	postsByAuthor: [],
	total: 0,
	errors: [],
	popularAuthors: [],
	postsByLocation: [],
	postsByLocationLoading: false,
	violations: [],
	uploadFile: null,
	fileLoading: false,
	pageCount: 0,
	pollVoting: false,
	postTimer: [],
	pollTimerLoading: false,
	postPollUsers: [],
	postPollUsersLoading: false,
	totalCount: 0,
	poll_status: null,
	videoLink: null,
	videoLoading: false,
}

export const state = { ...initialState }

export default {
	[POST_VIDEO_PREVIEW]: (state, payload) => {
		state.videoLink = payload
	},
	[POST_VIDEO_PREVIEW_LOADING]: (state, status) => {
		state.videoLoading = status
	},
	[POST_POLL_STOP]: (state, payload) => {
		state.poll_status = payload
	},
	[POST_POLL_USERS]: (state, payload) => {
		state.postPollUsers = [...payload.data]
		state.pageCount = +payload.pageCount
		state.totalCount = +payload.totalCount
	},
	[POST_POLL_USERS_LOADING]: (state, payload) => {
		state.postPollUsersLoading = payload
	},
	[POST_POLL_TIMER]: (state, payload) => {
		state.postTimer = payload
	},
	[POST_POLL_TIMER_LOADING]: (state, status) => {
		state.pollTimerLoading = status
	},
	[POST_LOADING_STATUS]: (state, status) => {
		state.loading = status
	},

	[POST_FILE_LOADING_STATUS]: (state, status) => {
		state.fileLoading = status
	},

	[POSTS_FETCH]: (state, payload) => {
		state.post = initialState.post
		state.posts = [...payload.data]
		state.pageCount = payload.pageCount
		// state.total = payload.meta['last_page'];
	},

	[POSTS_FETCH_BY_CATEGORY]: (state, payload) => {
		state.post = initialState.post
		state.posts = [...payload.data]
		state.total = payload.meta['last_page']
	},

	[POSTS_FETCH_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_GET_ERROR_NOT_FOUND]: (state, status) => {
		state.postNotFound = status
	},

	[POSTS_FETCH_BY_AUTHOR]: (state, payload) => {
		state.postsByAuthor = [...payload.data]
	},

	[POSTS_FETCH_BY_AUTHOR_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_GET]: (state, payload) => {
		state.post = payload
	},

	[POST_COMMENTS_GET]: (state, payload) => {
		state.comments = payload
	},

	[POST_UPLOAD_FILE]: (state, payload) => {
		state.uploadFile = payload
	},

	[POST_COMMENT_LIKE_STATUS]: (state, status) => {
		state.loading = status
	},

	[POST_COMMENT_LIKE]: (state, { comment, payloadData }) => {
		const updatedLikedComment = (comments, targetId, commentData) => {
			return comments.map((comment) => {
				const { upvote, upvote_count } = commentData

				if (comment.thread_reply_id === targetId) {
					comment = { ...comment, upvote, upvote_count }
				} else if (comment.replies && comment.replies.length > 0) {
					comment.replies = updatedLikedComment(comment.replies, targetId, commentData)
				}

				return comment
			})
		}

		state.comments = [...updatedLikedComment(state.comments, comment.id, payloadData)]
	},

	[POST_COMMENT_LIKE_ERROR]: (state, error) => {
		state.errors = error.response.data
	},

	[POST_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_ADD]: (state, payload) => {
		state.post = payload
		state.posts = [...state.posts, payload]
	},

	[POST_ADD_ERROR]: (state, error) => {
		state.errors = error.response.data
	},

	[POST_UPDATE]: (state, payload) => {
		state.property = payload
	},

	[POST_UPDATE_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_DELETE]: (state, id) => {
		state.postsByAuthor = state.postsByAuthor.filter((post) => post.id !== id)
	},

	[POST_DELETE_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_COMMENT_ADD_STATUS]: (state, status) => {
		state.commentAdding = status
	},

	[POST_COMMENT_ADD_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_EVENT_COMMENT_ADD]: (state, payload) => {
		state.comments = [...state.comments, payload]
	},
	[POST_EVENT_COMMENT_ADD_STATUS]: (state, status) => {
		state.commentAdding = status
	},
	[POST_EVENT_COMMENT_ADD_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_COMMENT_GET]: (state, payload) => {
		state.comments = payload
	},

	[POST_COMMENT_ADD]: (state, payload) => {
		state.comments = [payload, ...state.comments]
	},

	[POST_COMMENT_GET_STATUS]: (state, status) => {
		state.commentLoading = status
	},

	[POST_COMMENT_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_COMMENT_UPDATE]: (state, payload) => {
		const updateCommentRecursive = (comments, updatedComment) => {
			return comments.map((comment) => {
				if (comment.thread_reply_id === updatedComment.thread_reply_id) {
					return {
						...comment,
						...updatedComment,
					}
				}

				if (comment.replies && comment.replies.length) {
					return {
						...comment,
						replies: updateCommentRecursive(comment.replies, updatedComment),
					}
				}

				return comment
			})
		}

		state.comments = updateCommentRecursive(state.comments, payload)
	},

	[POST_COMMENT_REPLY]: (state, { payload, parentId }) => {
		const addReplyToComment = (comments, targetId, newReply) => {
			return comments.map((comment) => {
				if (comment.thread_reply_id === targetId) {
					comment.replies = [...comment.replies, newReply]
				} else if (comment.replies && comment.replies.length > 0) {
					comment.replies = addReplyToComment(comment.replies, targetId, newReply)
				}

				return comment
			})
		}

		state.comments = [...addReplyToComment(state.comments, parentId, payload)]
	},

	[POST_COMMENT_REPLY_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_COMMENT_REPLY_STATUS]: (state, status) => {
		state.replyLoading = status
	},

	[POST_COMMENT_REPLY_DELETE]: (state, { reply }) => {
		const comments = [...state.comments]
		const findItemNested = (arr, itemId, nestingKey) =>
			arr.reduce((a, item, index, replyArray) => {
				if (a) return a
				if (item.id === itemId) {
					return replyArray.splice(index, 1)
				}
				if (item[nestingKey]) return findItemNested(item[nestingKey], itemId, nestingKey)
			}, null)
		findItemNested(comments, reply.id, 'replies')
		state.comments = [...comments]
	},

	[POST_COMMENT_REPLY_DELETE_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_COMMENT_REPLY_DELETE_STATUS]: (state, status) => {
		state.commentDeleting = status
	},

	[POST_COMMENT_UPDATE_STATUS]: (state, status) => {
		state.commentUpdating = status
	},

	[POST_COMMENT_UPDATE_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_COMMENT_DELETE]: (state, comment) => {
		const deleteCommentRecursive = (comments, targetId) => {
			return comments.filter((comment) => {
				if (comment.thread_reply_id === targetId) {
					return false
				} else if (comment.replies && comment.replies.length > 0) {
					comment.replies = deleteCommentRecursive(comment.replies, targetId)
				}

				return true
			})
		}

		state.comments = [...deleteCommentRecursive(state.comments, comment.id)]
	},

	[POST_COMMENT_DELETE_STATUS]: (state, status) => {
		state.commentDeleting = status
	},

	[POST_COMMENT_DELETE_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POSTS_NEARBY_FETCH_LOADING]: (state, status) => {
		state.postsByLocationLoading = status
	},

	[POSTS_NEARBY_FETCH]: (state, payload) => {
		state.postsByLocation = [...payload.data]
	},

	[POSTS_NEARBY_FETCH_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_FEATURED_LOADING]: (state, status) => {
		state.featuredPostLoading = status
	},

	[POST_FEATURED_GET]: (state, payload) => {
		state.featuredPost = payload
		state.comments = payload.comments
	},

	[POST_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_REPORT]: (state, payload) => {
		state.posts = state.posts.filter((item) => item.id !== payload)
	},

	[POST_REPORT_STATUS]: (state, status) => {
		state.reportAdding = status
	},

	[POST_REPORT_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_VIOLATIONS_GET]: (state, payload) => {
		state.violations = payload
	},

	[POST_VIOLATIONS_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},
	[POST_POLL_VOTING]: (state, payload) => {
		state.pollVoting = payload
	},
	[POST_POLL_VOTING_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},
	[POST_POLL_LIST_UPDATE]: (state, updatedPost) => {
		const id = updatedPost.thread_id

		state.posts = state.posts.map((p) => (p.thread_id === id ? { ...p, ...updatedPost } : p))

		if (state.post && state.post.thread_id === id) {
			state.post = { ...state.post, ...updatedPost }
		}
	},
	[POST_UPDATE_STATUS]: (state, status) => {
		state.isPostUpdating = status
	},
}
